<template>
  <li>
    <div class="box grid grid-responsive week_notes_lesson_note"
         :style="{ borderColor: event.color }">
      <div class="col-2-12 box-size">
            <span class="bold">{{event.title}}
              <br>
              {{$filters.timeStamp(event.start)}} - {{$filters.timeStamp(event.end)}}<br>
            </span>
      </div>
      <div class="col-10-12">
        <div class="col-1-3">
          <div class="word-break" v-html="learningGoal"></div>
        </div>
        <div class="col-1-3">
          <div class="word-break" v-html="description"></div>
        </div>
        <div class="col-1-3">
          <div class="word-break" v-html="notes_for_students"></div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import moment from 'moment' // eslint-disable-line no-unused-vars

  export default {
    props: ['event', 'date'],
    computed: {
      learningGoal () {
        return this.event.learning_goal
      },
      description () {
        return this.event.description
      },
      notes_for_students () {
        return this.event.notes_for_students
      }
    }
  }
</script>
<style>
  .box.week_notes_lesson_note {
    font-size: 13px;
    background: #f6f7f8;
    border-left: 3px solid #e74c3c;
    border-radius: 3px;
    overflow: hidden;
    padding: 10px 20px;
    margin-bottom: 10px;
  }

  .week_notes_lesson_note .word-break > a {
    word-break: break-all;
  }

  .week_notes_lesson_note .word-break > p:last-child {
    margin-bottom: 0;
  }

  .box.week_notes_lesson_note ul, .box.week_notes_lesson_note ol {
    margin-left: 10px;
    padding-left: 1.5em;
  }

  .box.week_notes_lesson_note ul li {
    list-style-type: disc;
  }

  .box.week_notes_lesson_note ol li {
    list-style-type: decimal;
  }
</style>



// WEBPACK FOOTER //
// WeekPlanLesson.vue?f1c84dcc